import { Component, OnInit } from '@angular/core';

import { FeatureFlagUtilService } from 'v2/modules/shared';
import { trackById } from 'v2/modules/shared/util/track-by.util';

import { IColumnConfig } from '../../../shared/interfaces/table.interface';
import { ChannelTableConfig } from '../../configs/channel-table.config';

@Component({
  selector: 'lum-channel',
  templateUrl: './channel.component.html',
  styleUrls: ['./channel.component.scss'],
})
export class ChannelComponent implements OnInit {
  columns :IColumnConfig[] = ChannelTableConfig.columns;

  trackById = trackById;

  constructor(private featureFlagUtilService :FeatureFlagUtilService) {}

  ngOnInit() :void {}
}
